const ctx = require.context("./", false, /^\.\/(?!index).*\.js$/);

const blogs = ctx
  .keys()
  .map((key) => ctx(key).default)
  .filter(Boolean)
  .sort((a, b) => new Date(b.dateISO) - new Date(a.dateISO));

export const getBlogBySlug = (slug) => blogs.find((b) => b.slug === slug);

export default blogs;
